import { create } from 'zustand';

const FILTER_STORAGE_KEY = 'showroom-filters';

interface FilterStore {
  lastFilterParams: string;
  setLastFilterParams: (params: string) => void;
  getShowroomUrl: () => string;
}

function loadStoredFilters(): string {
  try {
    return localStorage.getItem(FILTER_STORAGE_KEY) || '';
  } catch {
    return '';
  }
}

function saveFilters(params: string) {
  try {
    localStorage.setItem(FILTER_STORAGE_KEY, params);
  } catch {
    // Ignore storage errors
  }
}

export const useFilterStore = create<FilterStore>((set, get) => ({
  lastFilterParams: loadStoredFilters(),
  
  setLastFilterParams: (params: string) => {
    saveFilters(params);
    set({ lastFilterParams: params });
  },
  
  getShowroomUrl: () => {
    // Always return the new category-first landing. Saved filter params
    // belong to the legacy flat gallery and shouldn't be re-applied to the
    // tile grid.
    return '/showroom';
  },
}));
